const myStyles = theme => ({
  appbar: {
    zIndex: 1301
  },
  menuBtn: {
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  menuIcon: {
    marginRight: theme.spacing(2)
  },
  zin: {
    zIndex: "1302 !important"
  },

  title: {
    fontFamily: "cursive"
  },
  username: {
    fontFamily: "cursive",
    marginRight: theme.spacing(1)
  }
});

export default myStyles;
